import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-individual-report",
  templateUrl: "./individual-report.component.html",
  styleUrls: ["./individual-report.component.scss"]
})
export class IndividualReportComponent implements OnInit {
  @Input() dataIndividualReport: any;
  @Input() mobile: boolean = false;
  @Output() showTooltip: EventEmitter<string> = new EventEmitter<string>();
  public searchString: string;
  public tableHeads = [
    "# - Obligación",
    "Documento",
    "Nombre",
    "Valor",
    "Fecha de mora",
    "Última gestión",
    "Fecha última gestión",
    "Mejor gestión (mes anterior)",
    "Fecha mejor gestión",
    "Observaciones"
  ];

  constructor() {}

  ngOnInit() {}

  filter(value: string) {
    this.searchString = value;
  }

  handleTooltip(message?: string) {
    this.showTooltip.emit(message);
  }
}
